'use client';

import { useParams } from 'next/navigation';

import { useLoadSavedFilters } from '../../hooks/useLoadSavedFilters';

export const GridFiltersLoader = () => {
	const { slug: slugArray } = useParams<{ slug?: string[] }>();
	const slug = slugArray?.[1];

	useLoadSavedFilters(!!slug);

	return null;
};
